import InfoPersoStep5FormComponent from '../../components/info-perso/InfoPersoStep5FormComponent';


export default function InfoPersoStep5Bloc() {

      return (
        <div className="">
          <div className="">
            {/* <h2 className="card-title bleu">Confirmez vos modalités de contact</h2> */}
            <p className='text mt-sm'></p>
            <InfoPersoStep5FormComponent/>
          </div>
          
        </div>
      )
}